module.exports = __webpack_public_path__ + "static/img/eisart-logo.d1e0888.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eisart-logo.jpg
// module id = U1OL
// module chunks = 0